import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["field", "preview", "clear"]
    static values = { placeholder: { type: String, default: "☺️" } }

    pick(event) { this.set(event.detail.emoji) }
    clear() { this.set("") }

    set(emoji) {
        this.fieldTarget.value = emoji
        this.previewTarget.textContent = emoji || this.placeholderValue
        this.clearTarget.hidden = !emoji
        this.fieldTarget.dispatchEvent(new Event("change", { bubbles: true }))
    }
}
